import { getExperienceLevel } from "./experienceLevel";

import type { SoundName } from "cuelume";

/**
 * Puerta perezosa a la capa sonora.
 *
 * `landingSound.ts` arrastra `cuelume` (8 KB / 2,6 KB en la red). Importándolo de forma
 * estática, ese chunk viaja en la home aunque el sonido no se vaya a usar nunca — y en
 * experiencia reducida no se usa nunca, por definición. Acá el `import()` sólo ocurre
 * cuando el nivel es `full`, así que en un equipo limitado el audio no se descarga, no se
 * inicializa y no crea ningún `AudioContext`.
 *
 * En `full` el módulo ya quedó en caché por `initLandingSoundIfFull`, así que el `sfx` de
 * un click resuelve en el mismo tick y no se escucha ningún retraso.
 */
export async function initLandingSoundIfFull() {
  if (typeof window === "undefined" || getExperienceLevel() !== "full") return;
  const mod = await import("./landingSound");
  mod.initLandingSound();
}

export function sfxIfFull(name: SoundName) {
  if (typeof window === "undefined" || getExperienceLevel() !== "full") return;
  void import("./landingSound").then((mod) => mod.sfx(name));
}
